import ChromeReaderModeIcon from '@mui/icons-material/ChromeReaderMode';
import MyLocationIcon from '@mui/icons-material/MyLocation';
import PersonIcon from '@mui/icons-material/Person';
import { Box, Grid, FormControlLabel, Checkbox, Card, Stack } from '@mui/material';
import { IConsultant } from 'wisestep-api';
import {
  WsTypography,
  WsTypoVariants,
  WsTypoColors,
  WsIconText,
  WsDetailsObj,
  WsIconLocation,
  WsIconActiveJob,
  WsTagsList,
  ChipsType,
  WsIconTag,
} from 'wisestep-base';

interface ConsultantCardProps {
  consultant: IConsultant;
  checkBoxOnclick: () => void;
  isActiveCard: boolean;
  gridXs: number;
  isSelected: boolean;
  isCheckBox: boolean;
}

const getConsultantDetails = (consultant: IConsultant): WsDetailsObj[] => {
  const array: WsDetailsObj[] = [];
  if (consultant.location) {
    array.push({
      icon: <WsIconLocation />,
      labelName: `${consultant.location.country},${consultant.location.city} `,
    });
  }
  if (consultant.jobTitle) {
    array.push({
      icon: <WsIconActiveJob />,
      labelName: consultant.jobTitle,
    });
  }
  if (consultant.willingToRelocate != null) {
    array.push({
      icon: <MyLocationIcon />,
      labelName: consultant.willingToRelocate ? 'Willing To Relocate' : 'Not Willing To Relocate',
    });
  }
  if (consultant.totalYearsExperience) {
    array.push({
      icon: <ChromeReaderModeIcon />,
      labelName: consultant.totalYearsExperience,
    });
  }

  return array;
};

const ConsultantCard = ({
  consultant,
  checkBoxOnclick,
  isActiveCard = true,
  gridXs,
  isSelected,
  isCheckBox,
}: ConsultantCardProps) => {
  const details = getConsultantDetails(consultant);

  return (
    <Card>
      <Box p={2}>
        <Grid container item xs={12}>
          <Grid item xs={12}>
            <Box pl={1}>
              <FormControlLabel
                control={
                  isCheckBox ? (
                    <Checkbox onClick={checkBoxOnclick} checked={isSelected} size="small" />
                  ) : (
                    <></>
                  )
                }
                label={
                  <Grid container item xs={12}>
                    <Box pt={0.5} pr={0.5}>
                      <PersonIcon color="primary" />
                    </Box>
                    <Box pt={0.2}>
                      <WsTypography
                        variant={WsTypoVariants.SUB_TITLE}
                        color={isActiveCard ? WsTypoColors.BLACK : WsTypoColors.SECONDARY}
                      >
                        {consultant.name}
                      </WsTypography>
                    </Box>
                  </Grid>
                }
              />
            </Box>
          </Grid>
        </Grid>

        <Grid container item xs={12} pl={2} py={1} spacing={1}>
          {details?.map((detailsObj, index) => (
            <Grid item xs={gridXs} key={index}>
              <WsIconText
                icon={detailsObj.icon ?? <></>}
                text={detailsObj.labelName ?? ''}
                opacity={true}
              />
            </Grid>
          ))}

          <Stack direction="row" mt={1}>
            <Box pt={1} pr={0.6} display="flex">
              <WsIconTag />
            </Box>
            <Box pt={0.5} pr={0.6} display="flex">
              <WsTypography variant={WsTypoVariants.SUB_TITLE} color={WsTypoColors.GREEN}>
                Skills :
              </WsTypography>
            </Box>
            <WsTagsList
              chipArray={consultant?.skills?.map((skills) => skills.skill ?? 'No Data') ?? []}
              count={3}
              type={ChipsType.SECONDARY}
            />
          </Stack>
        </Grid>
      </Box>
    </Card>
  );
};

export default ConsultantCard;
